/**
 * Instancie une demande de suppression qu'a réalisé un membre.
 */
export class MembreDemandeSuppression {
    /**
     * Constructeur de l'objet MembreDemandeSuppression
     * @param row array contenant les données de l'objet
     */
    constructor(row) {
        if (row) {
            const { idDemandeSuppression, idMembre, dateEnregistrement, verifDemande } = row;
            this.idDemandeSuppression = idDemandeSuppression !== null && idDemandeSuppression !== void 0 ? idDemandeSuppression : null;
            this.idMembre = idMembre !== null && idMembre !== void 0 ? idMembre : null;
            this.dateEnregistrement = dateEnregistrement !== null && dateEnregistrement !== void 0 ? dateEnregistrement : null;
            this.verifDemande = verifDemande !== null && verifDemande !== void 0 ? verifDemande : null;
        }
    }
    /**
     * Utilisée pour renvoyer les informations au front.
     */
    toRaw() {
        return {
            idDemandeSuppression: this.idDemandeSuppression,
            idMembre: this.idMembre,
            dateEnregistrement: this.dateEnregistrement,
            verifDemande: this.verifDemande,
        };
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTWVtYnJlRGVtYW5kZVN1cHByZXNzaW9uLmNsYXNzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiTWVtYnJlRGVtYW5kZVN1cHByZXNzaW9uLmNsYXNzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBOztHQUVHO0FBQ0gsTUFBTSxPQUFPLHdCQUF3QjtJQXFCcEM7OztPQUdHO0lBQ0gsWUFBbUIsR0FBdUM7UUFDekQsSUFBSSxHQUFHLEVBQUU7WUFDUixNQUFNLEVBQUUsb0JBQW9CLEVBQUUsUUFBUSxFQUFFLGtCQUFrQixFQUFFLFlBQVksRUFBRSxHQUFHLEdBQUcsQ0FBQztZQUNqRixJQUFJLENBQUMsb0JBQW9CLEdBQUcsb0JBQW9CLGFBQXBCLG9CQUFvQixjQUFwQixvQkFBb0IsR0FBSSxJQUFJLENBQUM7WUFDekQsSUFBSSxDQUFDLFFBQVEsR0FBRyxRQUFRLGFBQVIsUUFBUSxjQUFSLFFBQVEsR0FBSSxJQUFJLENBQUM7WUFDakMsSUFBSSxDQUFDLGtCQUFrQixHQUFHLGtCQUFrQixhQUFsQixrQkFBa0IsY0FBbEIsa0JBQWtCLEdBQUksSUFBSSxDQUFDO1lBQ3JELElBQUksQ0FBQyxZQUFZLEdBQUcsWUFBWSxhQUFaLFlBQVksY0FBWixZQUFZLEdBQUksSUFBSSxDQUFDO1NBQ3pDO0lBQ0YsQ0FBQztJQUVEOztPQUVHO0lBQ0ksS0FBSztRQUNYLE9BQU87WUFDTixvQkFBb0IsRUFBRSxJQUFJLENBQUMsb0JBQW9CO1lBQy9DLFFBQVEsRUFBRSxJQUFJLENBQUMsUUFBUTtZQUN2QixrQkFBa0IsRUFBRSxJQUFJLENBQUMsa0JBQWtCO1lBQzNDLFlBQVksRUFBRSxJQUFJLENBQUMsWUFBWTtTQUMvQixDQUFDO0lBQ0gsQ0FBQztDQUNEIn0=